<template>
  <component :class="baseClass" :disabled="busy" :is="buttonType" :href="href" :title="toolTip">
    <slot v-if="busy" name="loading">
      <span class="spinner-border spinner-border-sm me" role="status" aria-hidden="true" />
    </slot>
    <slot v-if="(busy && !busyHideMessage) || !busy"><i :class="getIconButton" :style="getStyleIcon"></i><span v-html="props.title"></span></slot>
  </component>
</template>

<style scoped>
.me {
  margin-right: 4px;
}
</style>

<script setup>
import { computed, defineProps, defineExpose, ref } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: 'Button',
  },
  variant: {
    type: String,
    default: 'primary',
  },
  href: {
    type: String,
    default: null,
  },
  busyHideMessage: {
    type: Boolean,
    default: false,
  },
  marginTop: {
    type: Number,
    default: 1,
  },
  iconButton: {
    type: String,
    default: '',
  },
  toolTip: {
    type: String,
    default: '',
  },
  styleIcon: {
    type: String,
    default: '',
  },
});

const buttonType = computed({
  get: () => (props.href ? 'a' : 'button'),
});

const getVariant = computed({
  get: () => (props.variant ? `btn-${props.variant}` : 'btn-primary'),
});

const marginTopClass = computed({
  get: () => (props.marginTop >= 0 ? `mt-${props.marginTop}` : 'mt-2'),
});

const getIconButton = computed({
  get: () => (props.iconButton ? `${props.iconButton} me-1` : ''),
});

const getStyleIcon = computed({
  get: () => (props.styleIcon ? `color: ${props.styleIcon}` : ''),
});

const baseClass = computed({
  get() {
    return [
      'btn',
      'waves-effect',
      'waves-float',
      'waves-light',
      getVariant.value,
      marginTopClass.value,
    ];
  },
});

const busy = ref(false);

function lock() {
  busy.value = true;
}

function unlock() {
  busy.value = false;
}

defineExpose({
  lock,
  unlock,
});
</script>
